@if (visible()) {
  <div class="ws-selector-ia-switch" [class.ws-selector-ia-switch--pending]="pending()">
    <so-switch-ui
      [label]="'ws_sync_switch_label' | translated : 'Sincronizar desde WS de marca'"
      [labelOnLeft]="true"
      [colorStyle]="'verde'"
      [isChecked]="active()"
      [controlled]="true"
      [isDisabled]="pending()"
      [tooltip]="pending() ? ('ws_sync_pending_tooltip' | translated : 'Sincronización en curso, espera a que termine') : ''"
      (statusChecked)="onToggle($event)"
    />
  </div>
}
